import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=2e1c3e24&scoped=true"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"
import style0 from "./feedback.vue?vue&type=style&index=0&id=2e1c3e24&lang=scss&scoped=true"
import style1 from "./feedback.vue?vue&type=style&index=1&id=2e1c3e24&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1c3e24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e1c3e24')) {
      api.createRecord('2e1c3e24', component.options)
    } else {
      api.reload('2e1c3e24', component.options)
    }
    module.hot.accept("./feedback.vue?vue&type=template&id=2e1c3e24&scoped=true", function () {
      api.rerender('2e1c3e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/serviceCenter/feedback.vue"
export default component.exports